import { createFileRoute } from "@tanstack/react-router";

import { ServicePageLayout } from "../components/site/ServicePageLayout";
import { BitrixHero } from "../components/bitrix24/BitrixHero";
import { BitrixBox } from "../components/bitrix24/BitrixBox";
import { BitrixFeatures } from "../components/bitrix24/BitrixFeatures";
import { BitrixEnterprise } from "../components/bitrix24/BitrixEnterprise";
import { BitrixIntegrations } from "../components/bitrix24/BitrixIntegrations";
import { Reviews } from "../components/shared/Reviews";
import { Team } from "../components/shared/Team";
import { Stats } from "../components/shared/Stats";
import { LeadForm } from "../components/shared/LeadForm";
import { buildMeta, serviceJsonLd, SITE_URL } from "../lib/site";

const title = "Внедрение Битрикс24 под ваш бизнес от 2 недель — hay.agency";
const description =
  "Внедряем Битрикс24: коробочная и облачная версии, CRM и портал, интеграции с телефонией, кассами и мессенджерами, сопровождение.";

export const Route = createFileRoute("/bitrix24")({
  head: () => ({
    ...buildMeta({ title, description, path: "/bitrix24", image: `${SITE_URL}/og/services/bitrix24.webp`, imageWidth: 1200, imageHeight: 630, imageAlt: "Внедрение Битрикс24 — HAY.agency", locale: "ru_RU" }),
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify(
          serviceJsonLd({
            name: "Внедрение Битрикс24",
            description,
            path: "/bitrix24",
          }),
        ),
      },
    ],
  }),
  component: Page,
});

function Page() {
  return (
    <ServicePageLayout breadcrumb="Битрикс24">
      <BitrixHero />
      <BitrixBox />
      <BitrixFeatures />
      <BitrixEnterprise />
      <BitrixIntegrations />
      <Reviews />
      <Team />
      <Stats />
      <LeadForm
        id="event"
        title={
          <>
            Давайте обсудим, как масштабировать ваш бизнес{" "}
            <span className="text-display-muted">через Битрикс24</span>
          </>
        }
        lead="Оставьте контакты — предложим сценарий внедрения Битрикс24 под ваши процессы."
        submitLabel="Обсудить проект"
      />
    </ServicePageLayout>
  );
}
